import { Mail, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Heading, Text } from "@/components/ui/typography";

type WorkerProfile = {
  fullName: string;
  email?: string;
  phoneNumber?: string;
  company?: string;
  jobTitle?: string;
};

function ProfileInfoCard({ profile }: { profile: WorkerProfile }) {
  if (!profile) {
    return null;
  }

  const hasEmail = profile?.email;
  const hasPhone = profile?.phoneNumber;

  return (
    <Card className="mx-auto w-full max-w-md bg-card-foreground text-background shadow-[var(--surface-shadow)]">
      <CardContent className="px-6">
        <div className="space-y-4">
          <div>
            <Heading variant="section" as="h1" className="text-background">
              {profile.fullName || "Worker"}
            </Heading>
            <Text variant="lead" className="text-background/70">
              {[profile.company, profile.jobTitle].filter((x) => x).join(" — ")}
            </Text>
          </div>

          <div className="flex items-center gap-3">
            <Button
              size="icon"
              variant="overlay"
              className="rounded-full"
              disabled={!hasEmail}
              {...(hasEmail && { asChild: true })}
            >
              {hasEmail ? (
                <a
                  href={`mailto:${profile.email}`}
                  aria-label={`Email ${profile.email}`}
                >
                  <Mail className="h-4 w-4" />
                </a>
              ) : (
                <Mail className="h-4 w-4" />
              )}
            </Button>

            <Button
              size="icon"
              variant="overlay"
              className="rounded-full"
              disabled={!hasPhone}
              {...(hasPhone && { asChild: true })}
            >
              {hasPhone ? (
                <a
                  href={`tel:${profile.phoneNumber}`}
                  aria-label={`Call ${profile.phoneNumber}`}
                >
                  <Phone className="h-4 w-4" />
                </a>
              ) : (
                <Phone className="h-4 w-4" />
              )}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export { ProfileInfoCard };
export type { WorkerProfile };
